import {
  Background,
  BackgroundGlobalStyles,
  Box,
  FakeInput,
  SearchboxStartpageMetadata,
  Title,
  Keywords,
  TeaserOnSide,
} from './components';

type Props = {
  withPromotions?: boolean;
  showPromotionsAsButtons?: boolean;
  isStartPage?: boolean;
  withKeywords?: boolean;
  withTitle?: boolean;
};

export const SearchBar: React.FC<Props> = ({
  withPromotions = false,
  showPromotionsAsButtons = false,
  isStartPage,
  withTitle = true,
  withKeywords = false,
}) => {
  return (
    <>
      <BackgroundGlobalStyles />
      <Background $showPromotionsAsButtons={showPromotionsAsButtons}>
        {isStartPage ? <SearchboxStartpageMetadata /> : null}
        <Box>
          {withTitle ? <Title /> : null}
          <FakeInput
            withPromotions={withPromotions}
            showPromotionsAsButtons={showPromotionsAsButtons}
            withTitle={withTitle}
          />
        </Box>
        {withKeywords ? <Keywords isStartPage={isStartPage} /> : null}
        <TeaserOnSide />
      </Background>
    </>
  );
};
